"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allowedSides = [6];
var DiceIntegrityService = /** @class */ (function () {
    function DiceIntegrityService() {
    }
    DiceIntegrityService.verifyIntegrity = function (props) {
        if (!exports.allowedSides.includes(props.sides)) {
            throw new Error("Trying to show a d" + props.sides + "; however, only these are supported: d" + exports.allowedSides.join(', d'));
        }
        if (props.value < 1) {
            throw new Error("The value must be greater than one, provided: " + props.value);
        }
        if (props.value > props.sides) {
            throw new Error("The value (" + props.value + ") can't be greater than the number of sides (" + props.sides + ")");
        }
    };
    return DiceIntegrityService;
}());
exports.DiceIntegrityService = DiceIntegrityService;
//# sourceMappingURL=dice-integrity-service.js.map